import { createSelector } from 'reselect';
import CarrierPaperFreeMonitoringDetailsColumns
  from '../../containers/CarrierPaperFreeMonitoringDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import CarrierPaperFreeMonitoringDetailsTotalColumns
  from '../../containers/CarrierPaperFreeMonitoringDetailsTotalColumns';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_903_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_903_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PAPER_FREE_MONITORING_CARRIER_903_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, CarrierPaperFreeMonitoringDetailsColumns);

export const getTotalColumns =
  createSelector(getData, CarrierPaperFreeMonitoringDetailsTotalColumns);
